import { useMutation } from '@tanstack/react-query';
import {
  removeCalendarSync,
  RemoveCalendarSyncInput,
} from 'shared/services/backend-api';

export const useRemoveCalendarSyncMutation = () =>
  useMutation({
    mutationFn: async (input: RemoveCalendarSyncInput) =>
      removeCalendarSync(input),
  });
